import { GalaxyColumnDef } from '@vendasta/galaxy/table/src/table.interface';

export const ITEMS_SELECTOR_COLUMNS: GalaxyColumnDef[] = [
  {
    id: 'checkbox',
    title: 'Checkbox',
  },
  {
    id: 'name',
    title: 'Name',
  },
  {
    id: 'quantityInput',
    title: 'Quantity',
  },
  {
    id: 'wholesale',
    title: 'Wholesale',
  },
  {
    id: 'retail',
    title: 'Retail',
  },
];
